import { Fragment, useEffect } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";

import { Breadcrumbs } from "AbstractElements";
import TheForm from "Components/Common/Component/form/TheForm";
import { useUserProfile } from "hook/useUserProfile";
import { useForm } from "react-hook-form";
import { formFields } from "./constant";

export const CurrentUser = () => {
  const { data, isFetched } = useUserProfile();
  const useFormReturn = useForm();

  useEffect(() => {
    if (isFetched && data) {
      useFormReturn.reset({
        ...data,
        userRoleId: data.userRole?.displayName
      });
    }
  }, [isFetched, data]);

  return (
    <Fragment>
      <Breadcrumbs title={"Thông tin người dùng"} parent={"Người dùng"} />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <TheForm {...useFormReturn} items={formFields} textOnly />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};
